import Crud from "../Crud";
import MUIBlueColor from "@mui/material/colors/blue";

/**
 * Static helper functions related to dashboard widgets.
 */
export default class DashboardWidget extends Crud {
    /**
     * @param {object} dashboardWidget The dashboard widget object.
     * @returns {string} Display name used in admin lists and editor headers.
     */
    static getDisplayName(dashboardWidget) {
        return dashboardWidget.name;
    }

    /**
     * Determines if a dashboard widget matches a search query.
     *
     * @param {object} dashboardWidget The dashboard widget to test.
     * @param {string} query The search query.
     * @returns {boolean} Whether or not the dashboard widget matches the query.
     */
    static match(dashboardWidget, query) {
        return (
            (dashboardWidget.name && dashboardWidget.name.toLowerCase().includes(query)) ||
            dashboardWidget.id === +query
        );
    }

    /**
     * @param {array} dashboardWidgets The list to sort.
     * @returns {array} The sorted list.
     */
    static sort(dashboardWidgets) {
        return dashboardWidgets.sort((a, b) => {
            return (a.ordinal || 0) - (b.ordinal || 0);
        });
    }

    /**
     * @returns {string} The color of this object.
     */
    static getBaseColor() {
        return MUIBlueColor;
    }

    /**
     * @returns {string} The icon name for this object.
     */
    static getIconName() {
        return "Widgets";
    }
}
